"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const computePrice_1 = require("../computePrice");
const utils_1 = require("../utils");
const orderItemHelper_1 = require("../orderItemHelper");
/**
 * Updates the price of an ORDER ITEM in an order.
 * Can only be done when the order is in IN_PROGRESS or in CREATED status
 * @param event of type UpdateOrderItemPriceEvent
 * @param prevState
 */
function default_1(event, prevState = {}) {
    var _a, _b, _c;
    let order = (0, utils_1.clone)(prevState);
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    order.orderItems = order.orderItems || [];
    const orderItem = order.orderItems.find(x => x.id === event.orderItemId);
    if (orderItem === undefined) {
        return order;
    }
    const price = (_a = event.unitPrice) !== null && _a !== void 0 ? _a : orderItem.unitPrice;
    const isPriceUpdated = event.unitPrice !== orderItem.unitPrice;
    const discounts = event.discounts || orderItem.discounts;
    const adjustments = event.adjustments || orderItem.adjustments;
    orderItem.unitPrice = price;
    orderItem.discounts = discounts || [];
    orderItem.adjustments = adjustments || [];
    // Re-calculate the combo products data
    if (isPriceUpdated &&
        ((_b = orderItem.comboItems) === null || _b === void 0 ? void 0 : _b.length) &&
        ((_c = event.originalProductPricing) === null || _c === void 0 ? void 0 : _c.length)) {
        const comboPricingMap = event.originalProductPricing.reduce((pricingMap, pricing) => {
            pricingMap[pricing.productId] = pricing;
            return pricingMap;
        }, {});
        const comboProductPriceMap = orderItem.comboItems.reduce((map, item) => {
            var _a;
            map = {
                ...map,
                [item.product.id]: {
                    quantity: item.quantity,
                    productOriginalPrice: comboPricingMap[item.product.id].amount,
                    modifiers: (_a = item.modifiers) !== null && _a !== void 0 ? _a : [],
                },
            };
            return map;
        }, {});
        (0, orderItemHelper_1.updateSavedAndProRatedAmount)(comboProductPriceMap, orderItem);
        (0, orderItemHelper_1.adjustProRateValue)(orderItem);
    }
    order = { ...order, ...(0, computePrice_1.computeOrderTotals)(order) };
    if (orderItem.adjustments) {
        orderItem.discountAmount = (0, computePrice_1.computeOrderItemDiscount)(orderItem);
        orderItem.surchargeAmount = (0, computePrice_1.computeOrderItemSurcharge)(orderItem);
    }
    return order;
}
exports.default = default_1;
//# sourceMappingURL=updateOrderItemPrice.js.map